export default __webpack_public_path__ + "static/media/type2.d4af7d7d.png";